import Component from '@glimmer/component';
import RouteTemplate from 'ember-route-template';
import LiveNewsTicker from '../../components/layout/live-news-ticker';
import EsportsPostComponent from '../../components/layout/news/esports-post';
import { pageTitle } from 'ember-page-title';

class EsportsNewsPostComponent extends Component {
  <template>
    {{pageTitle @model.title}}
    <LiveNewsTicker />
    <EsportsPostComponent @post={{@model}} />
  </template>
}

export default RouteTemplate(EsportsNewsPostComponent);
